module.exports = __webpack_public_path__ + "img/bg_hero-wide.fc4ad371.jpg";